<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-20 17:12:49
-->
<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { getBaseInfo } from '@/api/common.js';
import { setIcoAndTitle } from '@/utils/common.js';
import { requestTry } from '@/utils/request';
import HotFresh from '@/utils/hotFresh/index.js';
import * as types from '@/store/mutation-types.js';
import { defaultBaseInfo } from './utils/dataMap.js';
export default {
	computed: {
		...mapState(['loginStatus']),
	},
	mounted() {
		HotFresh.checkVersion({ updateVersion: true });
		this.getBaseInfoAjax();
	},
	methods: {
		async getBaseInfoAjax() {
			let baseInfo = {};
			try {
				const res = await requestTry(getBaseInfo, 3);
				const { code, data } = res;
				if (code == 0) {
					const { base_info } = data || {};
					baseInfo = base_info || {};
					// 删除无数据的key value， 使用默认值
					const keys = Object.keys(baseInfo);
					if (keys.length > 0) {
						keys.forEach(k => {
							if (!baseInfo[k]) {
								delete baseInfo[k];
							}
						});
					}
				}
				baseInfo = { ...defaultBaseInfo, ...baseInfo }; // 设置默认值
				this.$store.commit(types.BASE_INFO, baseInfo);
				setIcoAndTitle(baseInfo.tab_logo, baseInfo.website_title);
			} catch (e) {
				baseInfo = { ...defaultBaseInfo, ...baseInfo }; // 设置默认值
				this.$store.commit(types.BASE_INFO, baseInfo);
				setIcoAndTitle(baseInfo.tab_logo, baseInfo.website_title);
			}
		},
	},
};
</script>

<style lang="less">
@import './styles/index.less';

#app {
	font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	width: 100%;
	height: 100%;
	background-color: @background-color-base;
}
</style>
